// extracted by mini-css-extract-plugin
export var circle = "_2n-2";
export var icon = "_2n-a";
export var iconHighlight = "_2n-0";
export var lg = "_2n-8";
export var md = "_2n-7";
export var outline = "_2n-4";
export var sm = "_2n-6";
export var square = "_2n-1";
export var xl = "_2n-9";
export var xs = "_2n-5";
export var xxs = "_2n-3";